import { cn } from "@/lib/utils";

/**
 * 水平方向の線
 */
export const HorizontalLine = ({ className }: { className?: string }) => (
  <div className={cn("h-px w-full bg-monotone-2", className)} />
);
